<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: 'performanceAssignmentList' }">绩效分配</el-breadcrumb-item>
                <el-breadcrumb-item>{{ headerTitle }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <div>
                        <el-button size="small" plain @click="insert">新增</el-button>
                        <el-button size="small" plain @click="copy">复制</el-button>
                        <el-button size="small" plain @click="update">编辑</el-button>
                        <el-button size="small" plain @click="del">删除</el-button>
                        <draggableDetail :draggable="{ data_name: 'performance_assignment' }" @isErrshow="reload"></draggableDetail>
                    </div>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form label-position="right" :model="data" class="details" label-width="auto">
                        <template>
                            <el-row v-for="(item_out, index_out) in colData" :key="index_out">
                                <el-col :span="12" v-for="(item, index) in item_out" :key="index">
                                    <el-form-item :label="item.title ? item.title + '：' : ''">
                                        <div
                                            class="read_only read_only_link"
                                            v-if="
                                                in_array(item.prop, ['object_partner_name', 'object_product_name', 'object_account_name'])
                                            "
                                        >
                                            <span @click="toDetail(item.prop)">{{ data[item.prop] }}</span>
                                        </div>
                                        <el-input
                                            v-else
                                            v-model="data[item.prop]"
                                            class="flex_item_text"
                                            size="mini"
                                            readonly="readonly"
                                        ></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </template>
                    </el-form>
                </el-collapse-item>
                <el-collapse-item disabled title="绩效分配行" name="2">
                    <vPerformanceAssignmentLineComponent
                        v-if="flag"
                        :postList="performance_assignment_line_params"
                    ></vPerformanceAssignmentLineComponent>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { onDelete, in_array, processColumnDataToRowNew } from '@/js/common';
import draggableDetail from '../../../common/DrawerDetail.vue';
import vPerformanceAssignmentLineComponent from '@/components/page/listComponent/basicdata/performance/performanceAssignmentLineComponent.vue';
export default {
    inject: ['reload'],
    name: 'performanceAssignmentDetail',
    components: {
        draggableDetail,
        vPerformanceAssignmentLineComponent
    },
    data() {
        return {
            colData: [],
            activeNames: ['1', '2'],
            data: {},
            queryParams: {},
            headerTitle: '绩效分配详情',
            flag: false,
            performance_assignment_line_params: {}
        };
    },
    watch: {
        $route(to, from) {
            this.queryParams.rid = to.query.rid;
            this.reload();
        }
    },
    beforeMount() {
        this.selectedColData(); //筛选列
        this.initQueryParams();
    },
    mounted() {
        this.initSubListParams();
        this.$nextTick(() => {
            this.getData(); //获取详情
            this.flag = true;
        });
    },
    methods: {
        in_array,
        initSubListParams() {
            this.performance_assignment_line_params.params = {
                performance_assignment_rid: this.queryParams.rid,
                type: 'detail'
            };
        },
        toDetail(prop) {
            if (in_array(prop, ['object_partner_name']) && this.data.object_partner_rid) {
                this.$router.push({
                    path: '/partnerDetails',
                    query: {
                        id: this.data.object_partner_rid
                    }
                });
            } else if (in_array(prop, ['object_product_name']) && this.data.object_product_rid) {
                this.$router.push({
                    path: '/productListDetails',
                    query: {
                        id: this.data.object_product_rid
                    }
                });
            } else if (in_array(prop, ['object_account_name']) && this.data.object_account_rid) {
                this.$router.push({
                    path: '/accountDetails',
                    query: {
                        id: this.data.object_account_rid
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        //筛选列
        selectedColData() {
            let colData = JSON.parse(localStorage.getItem('detailList')).performance_assignment;
            processColumnDataToRowNew(colData, this);
        },
        //详情
        getData() {
            this.$api
                .performanceAssignmentDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    document.title = this.headerTitle + ':' + res.data.object_rid;
                })
                .catch((error) => {});
        },
        //新增
        insert() {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //复制
        copy() {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'copy',
                    id: this.data.rid
                }
            });
        },
        //编辑
        update() {
            this.$router.push({
                path: 'performanceAssignmentEdit',
                query: {
                    type: 'update',
                    id: this.data.rid
                }
            });
        },
        //删除
        del() {
            onDelete(this.data.id, this, 'performanceAssignmentDelete', this.data.rid, 'performanceAssignmentList');
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>